import { FC } from 'react';

import { Didactic } from '@savgroup-front-common/core/atoms/Didactic';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';

import plans from '@/configuration/plans.json';

import {
  $AvailablePlanContainer,
  $ChoosePricingContainer,
  $ChoosePricingHeader,
  $EmptyColumn,
} from './ChoosePlan.styles';
import { PlanDto } from './ChoosePlan.types';
import { ComparePlans } from './ComparePlans/ComparePlans';
import messages from './messages';
import { PlanPreview } from './PlanPreview/PlanPreview';

export const ChoosePlan: FC<{ isFromScratch?: boolean }> = ({
  isFromScratch = false,
}) => {
  const availablePlans = plans as PlanDto[];

  return (
    <$ChoosePricingContainer isFromScratch={isFromScratch}>
      <$ChoosePricingHeader>
        <Heading level={3}>
          <SafeFormattedMessageWithoutSpread message={messages.title} />
        </Heading>
        <Didactic>
          <SafeFormattedMessageWithoutSpread message={messages.didactic} />
        </Didactic>
      </$ChoosePricingHeader>

      <$AvailablePlanContainer>
        <$EmptyColumn />

        {availablePlans.map((availablePlan) => {
          return (
            <PlanPreview
              key={availablePlan.id}
              plan={availablePlan}
              isFromScratch={isFromScratch}
            />
          );
        })}

        <ComparePlans plans={availablePlans} />
      </$AvailablePlanContainer>
    </$ChoosePricingContainer>
  );
};
